<template>
  <div class="countryCode">
    <div id="countryCode" :style="`width: ${country_box?82:118}px`">
      <div class="country-box" v-if="country_box" @click="countryBoxClick">
          +{{ country }}
      </div>
      <div class="select-box" v-else v-clickoutside="handleClose">
        <el-input class="countryCodeInput" ref="countryCodeInput" v-model="search"
                  @input="(val)=>{cardSearchInput(val)}" autofocus :placeholder="`+${country}`">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <i slot="suffix" class="el-icon-caret-bottom"></i>
        </el-input>
        <div class="list">
          <div class="item" :class="{'selectItem':selectCountry === item}"
               v-for="(item,index) in searchList(search,codeList)" :key="index" @click="itemClick(item)">
            <div class="country">{{ item.name }}</div>
            <div class="code">+{{ item.tel }}</div>
          </div>
        </div>
      </div>
    </div>
    <span/>
    <div class="input-box">
      <el-input class="phoneInput" v-model="myphone" placeholder="请输入手机号" @input="myphoneInput">
        <i slot="suffix"></i>
      </el-input>
    </div>
  </div>
</template>
<script>
let codes = require('../../assets/json/coutryCode.json')
const clickoutside = {
  // 初始化指令
  bind(el, binding, vnode) {
    function documentHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e)
      }
    }

    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.__vueClickOutside__ = documentHandler
    document.addEventListener('click', documentHandler)
  },
  update() {},
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  }
}
export default {
  directives: {clickoutside},
  name: "countryCode",
  props: {
    phone:{
      type:String,
      default:''
    }
  },
  components: {},
  data() {
    return {
      codeList: codes,
      //选中国家对象
      selectCountry: {},
      //国家区号
      country: '86',
      //关键词
      search: "",
      country_box: true,
      //手机号码
      myphone: this.phone
    }
  },
  methods: {
    /**
     * code || select切换
     */
    countryBoxClick() {
      this.country_box = false
      this.$nextTick(() => {
        this.$refs['countryCodeInput'].focus()
      })
    },
    /**
     * 下拉框点击事件
     * @param item
     */
    itemClick(item) {
      this.selectCountry = item
      this.country = `${item.tel} `
      this.country_box = true
      this.search = ''
      this.$emit('codeChange',item.tel)
    },
    /**
     * 点击其他地方 切换为code
     */
    handleClose() {
      this.country_box = true
      this.search = ''
    },
    /**
     * 下拉框值监听
     * @param val
     */
    cardSearchInput(val) {
      this.search = val
      this.$forceUpdate()
    },
    /**
     * 下拉框筛选
     * @param search 关键词
     * @param list
     * @returns {*}
     */
    searchList(search, list) {
      var reg = new RegExp(search, 'ig')
      return list.filter(function (e) {
        //匹配所有字段
        return Object.keys(e).some(function (key) {
          if (typeof e[key] == 'string') {
            return e[key].match(reg);
          }
        })
        this.$forceUpdate()
      })
      return list;
    },
    myphoneInput(val){
      this.$emit('phoneChange',val)
    }
  },
  watch: {},
  created() {

  },
  mounted() {
  }
}
</script>

<style scoped lang="less">
/deep/ .el-input__inner {
  border: none !important;
}

/deep/ .el-input__inner:focus {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.countryCode {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  border: 1px solid var(--border-soft, #E8E4DE);
  border-radius: 4px;
  margin: 0 0 10px;

  #countryCode {
    flex-shrink: 0;
    transition: width .2s;

    .country-box {
      flex-shrink: 0;
      height: 48px;
      line-height: 48px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      padding: 0 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
    }

    .select-box {
      /deep/ .el-input__inner {
        padding: 0 20px 0 40px !important;
        width: 118px;
      }

      /deep/ .el-input {
        margin: 0 !important;
        line-height: 48px !important;
      }

      /deep/ .el-input__inner {
        height: 48px !important;
        line-height: 48px !important;
      }

      /deep/ .el-input__prefix {
        left: 10px !important;
      }

      .list {
        max-height: 180px;
        background: #FFFFFF;
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1500);
        border-radius: 4px;
        padding: 5px 0;
        overflow: auto;
        min-width: 190px;
        position: absolute;
        z-index: 2;
        top: 55px;
        left: 0;

        .item {
          padding: 0 10px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          .country {
            margin-right: 5px;
          }

          > div {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #858585;
          }
        }

        .selectItem {
          background: var(--primary-soft, #FCEDE5);

          > div {
            color: var(--primary, #FF5A1F) !important;
          }
        }

        .item:hover {
          background: #FAFAFA;
        }
      }
    }

  }

  .input-box {
    flex: 1;
    min-width: 0;
    height: 48px;
    overflow: hidden;

    /deep/ .phoneInput,
    /deep/ .phoneInput.el-input--suffix {
      width: 100% !important;
    }

    /deep/ .el-input {
      width: 100%;
      height: 48px;
      margin: 0 !important;
      line-height: 48px !important;
    }

    /deep/.el-input__inner{
      width: 100%;
      height: 48px !important;
      line-height: 48px !important;
      padding: 0 15px !important;
      box-sizing: border-box;
      background: transparent;
    }
  }

  > span {
    width: 1px;
    height: 10px;
    background: #D2D2D2;
  }
}

</style>
